import { createPortal } from '@/features/common/contexts/Portal'

export const {
    Provider: EditAutomaticContainersModalPortalProvider,
    usePortal: useEditAutomaticContainersModalPortal,
} = createPortal()
